/*doc
---
title: JS Breakpoints
name: zz-js-breakpoints
category: base
---

Javascript module to retrieve and check for breakpoints.

```js
var { maxWidth, minWidth, get } = require('./Breakpoints');

// retrieves the value of the given breakpoint
get('sm');
get('md');
get('lg');

// checks if window width is greater than
// the given breakpoint
maxWidth('sm');
maxWidth('md');
maxWidth('lg');

// checks if window width is less or equal than
// the given breakpoint
minWidth('sm');
minWidth('md');
minWidth('lg');

// returns true or false

```

*/

let breakpoints = {
  sm: 685,
  md: 1024,
  lg: 1300
};

function get(breakpoint) {
  if (undefined === breakpoints[breakpoint]) {
    throw new Error('Breakpoint "' + breakpoint + '" does not exist.');
  }

  return breakpoints[breakpoint];
}

function minWidth (breakpoint) {
  return window.innerWidth <= get(breakpoint);
}

function maxWidth (breakpoint) {
  return window.innerWidth > get(breakpoint);
}

export default { get, minWidth, maxWidth };



// WEBPACK FOOTER //
// ./src/scripts/components/Breakpoints.js